import { Button, Card, Col, DatePicker, Row, Select, Skeleton, Tag } from "antd";
import { Fragment } from "react/jsx-runtime";
import Highcharts from "highcharts";
import "highcharts/modules/drilldown";
import HighchartsReact from "highcharts-react-official";
import { useState } from "react";
import { RegistrationbookedtypeView } from "./BookedType";
import { RegistrationAbandonmentView } from "./Abandonment-Rate";
import { RepeatParticipationView } from "./Repeat-Participation";
import { useGetDashboardCardCommon } from "features/dashboard/use-cases/get-commonDropDown";
import { FilterOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useGetDashboardExctuiveSummaryData } from "features/dashboard/use-cases/get-exctuive-summary";
import { useGetDashboardCardBoardPieCricleData } from "features/dashboard/use-cases/get-dashboard-cricle";
import { useUserContext } from "features/users";
const { RangePicker } = DatePicker;

export const RegistrationAnalysisstepPerMonth = () => {
    const today = dayjs();
    const currentYear = today.year();

    const [selectedMonths, setSelectedMonths] = useState<string[]>([]);
    const [selectedYear, setSelectedYear] = useState<number>(today.year());
      const { user } = useUserContext()
    
    // ✅ Initialize RangePicker with today’s date
    const [dateRange, setDateRange] = useState<[dayjs.Dayjs, dayjs.Dayjs] | null>('' as any);
// [
//         dayjs(),
//         dayjs(),
//     ]
    const [selectedEvent, setSelectedEvent] = useState<string | undefined>();
    const [selectedCategory, setSelectedCategory] = useState<string | undefined>();

    // month helpers
    const monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
    const monthFullNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const { data: eventsData } = useGetDashboardCardCommon({ Flag: "events",year:selectedYear,AgentId: user?.user_id });

    const { data: categoriesData } = useGetDashboardCardCommon(
        selectedEvent ? { Flag: "Categories", searchId: selectedEvent,AgentId: user?.user_id } : { enabled: false }
    );

    // build monthlist payload for API
    const monthListPayload =
        selectedMonths.length > 0
            ? selectedMonths.map((m) => monthShortNames.indexOf(m) + 1).join(",")
            : undefined;

    // API Call with filters
    const { data: ParticipantGraph } = useGetDashboardExctuiveSummaryData({
        Flag: "Participant",
        FromDate: dateRange?.[0]?.format("YYYY-MM-DD") || "",
        ToDate: dateRange?.[1]?.format("YYYY-MM-DD") || "",
        Year: selectedYear || "",
        EventId: selectedEvent || "",
        CategoryId: selectedCategory || "",
        monthlist: monthListPayload,
        AgentId: user?.user_id
    } as any);

    const { data: abandonmentrate, isFetching, refetch } = useGetDashboardCardBoardPieCricleData({
        Flag: "abandonmentrate",
        FromDate: dateRange?.[0]?.format("YYYY-MM-DD") || "",
        ToDate: dateRange?.[1]?.format("YYYY-MM-DD") || "",
        Year: selectedYear || "",
        EventId: selectedEvent || "",
        CategoryId: selectedCategory || "",
        AgentId: user?.user_id
    });

    // Month tabs static list
    const monthlyData = monthShortNames.map((m) => ({ month: m }));

    const handleMonthToggle = (month: string) => {
        setSelectedMonths((prev) =>
            prev.includes(month) ? prev.filter((m) => m !== month) : [...prev, month]
        );
    };
    const handleApplyFilters = () => {
        refetch();
    };
    const handleReset = () => {
        setSelectedYear(currentYear);
        setSelectedEvent(undefined);
        setDateRange([today, today]);
        refetch(); // 🔹 call API with reset filters
    };
    // Build series from API
    const monthlyDataFromApi =
        ParticipantGraph?.GraphData?.map((item: any) => ({
            name: monthShortNames[item.GMonth - 1],
            y: item.TotalParticipants || 0,
            drilldown: monthFullNames[item.GMonth - 1],
        })) || [];

    const drilldownSeriesFromApi =
        ParticipantGraph?.DrilldownData?.length
            ? Object.values(
                ParticipantGraph.DrilldownData.reduce((acc: any, day: any) => {
                    const monthFull = monthFullNames[day.GMonth - 1];
                    if (!acc[monthFull]) {
                        acc[monthFull] = {
                            id: monthFull,
                            name: `Daily Participants - ${monthFull}`,
                            type: "column",
                            color: "#fadb14",
                            data: [],
                        };
                    }
                    acc[monthFull].data.push([
                        `${day.GDay} ${monthShortNames[day.GMonth - 1]}`,
                        day.TotalParticipants || 0,
                    ]);

                    return acc;
                }, {})
            )
            : [];
    const baseSeriesData =
        selectedMonths.length === 0
            ? monthlyDataFromApi
            : selectedMonths.map((shortMonth) => {
                const monthIndex = monthShortNames.indexOf(shortMonth);
                const total =
                    ParticipantGraph?.DrilldownData?.filter((d: any) => d.GMonth - 1 === monthIndex)
                        .reduce((sum: number, d: any) => sum + (d.TotalParticipants || 0), 0) || 0;

                return { name: shortMonth, y: total };
            });

    const chartOptions: Highcharts.Options = {
        chart: { type: "column" },
        title: {
            text:
                selectedMonths.length === 0
                    ? "Participants per Month"
                    : `Participants for: ${selectedMonths.join(", ")}`,
        },
        lang: { noData: "No data found" },
        xAxis: { type: "category" },
        yAxis: { title: { text: "Participants" } },
        legend: { enabled: false },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: { enabled: true, format: "{point.y:.0f}" },
            },
        },
        tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat:
                '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>',
        },
        credits: { enabled: false },
        series: [
            {
                name:
                    selectedMonths.length === 0
                        ? "Monthly Participants"
                        : `Total (${selectedMonths.length} month${selectedMonths.length > 1 ? "s" : ""})`,
                type: "column",
                color: "#fadb14",
                colorByPoint: true,
                data: baseSeriesData,
            },
        ],
        ...(selectedMonths.length === 0 && { drilldown: { series: drilldownSeriesFromApi } }),
    } as any;

    const years = Array.from({ length: 16 }, (_, i) => {
        const year = currentYear - 10 + i;

        return { label: year.toString(), value: year };
    });

    // useEffect(() => {
    //     const chart = chartRef.current?.chart;
    //     if (chart) {
    //         if (isLoading) {
    //             chart.showLoading("Loading data...");
    //         } else {
    //             chart.hideLoading();
    //         }
    //     }
    // }, [isLoading]);

    return (
        <Fragment>
            {/* 🔹 Filters Row */}
            <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
                <Col span={24} style={{ padding: '0' }}>
                    <Card className="filtr_card filt_repn">
                        <RangePicker
                            style={{ marginRight: 16 }}
                            value={dateRange}
                            onChange={(dates) => {
                                setDateRange(dates as [dayjs.Dayjs, dayjs.Dayjs] | null);
                                // if (dates) setSelectedYear(null);
                            }}
                        />
                        <Select
                            options={years}
                            value={selectedYear}
                            onChange={(value) => {
                                setSelectedYear(value);
                                setDateRange(null as any);
                            }}
                            style={{ width: 120, marginRight: 16 }}
                            placeholder="Select Year"
                        />

                        <Select
                            placeholder="Filter by Event"
                            value={selectedEvent}
                            onChange={(value) => {
                                setSelectedEvent(value);
                                setSelectedCategory(undefined);
                            }}
                            style={{ width: 150, marginRight: 16 }}
                            allowClear
                            dropdownRender={(menu) => (
                                <div>
                                    <div
                                        style={{
                                            padding: 8,
                                            fontWeight: 500,
                                            borderBottom: "1px solid #f0f0f0",
                                        }}
                                    >
                                        <FilterOutlined style={{ marginRight: 6 }} />
                                        Select Event
                                    </div>
                                    {menu}
                                </div>
                            )}
                            options={
                                eventsData?.dropDownList?.map((e: any) => ({
                                    label: e.Name,
                                    value: e.Id,
                                })) || []
                            }
                        />

                        <Select
                            mode="multiple"
                            placeholder="Filter by Category"
                            value={selectedCategory}
                            onChange={(value) => setSelectedCategory(value)}
                            style={{ width: 250, marginRight: 16 }}
                            allowClear
                            maxTagCount={1} // 👈 show only first tag, rest as +N
                            maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`} // 👈 custom display
                            dropdownRender={(menu) => (
                                <div>
                                    <div
                                        style={{
                                            padding: 8,
                                            fontWeight: 500,
                                            borderBottom: "1px solid #f0f0f0",
                                        }}
                                    >
                                        <FilterOutlined style={{ marginRight: 6 }} />
                                        Select Category
                                    </div>
                                    {menu}
                                </div>
                            )}
                            options={
                                categoriesData?.dropDownList?.map((c: any) => ({
                                    label: c.Name,
                                    value: c.Id,
                                })) || []
                            }
                            disabled={!selectedEvent}
                        />

                        <Button
                            type="primary"
                            style={{ marginLeft: "16px", marginRight: "10px" }}
                            onClick={handleApplyFilters}
                        >
                            Filter
                        </Button>
                        <Button onClick={handleReset}>Cancel</Button>
                    </Card>
                </Col>
            </Row>
            {/* 🔹 Month tabs */}

            <Row>

                <Col span={24}>
                    <Card>


                        <Row gutter={[16, 16]} className="month_tabs anylsis_mnth">

                            {monthlyData.map((month) => (
                                <Col key={month.month}>
                                    <Tag
                                        color={selectedMonths.includes(month.month) ? "yellow" : "default"}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleMonthToggle(month.month)}
                                    >
                                        {month.month}
                                    </Tag>
                                </Col>
                            ))}


                        </Row>


                        <Col span={24} className="respn_col">
                            {/* <Spin spinning={isLoading} > */}
                            {isFetching ? <Skeleton/> :
                                <HighchartsReact highcharts={Highcharts} options={chartOptions} />}
                            {/* </Spin> */}
                        </Col>

                    </Card>
                </Col>
            </Row>
            {/* 🔹 Bottom widgets */}
            <Row gutter={[16, 16]} className="row_gap">
                <Col span={12} className="respn_col">
                    <RegistrationbookedtypeView dateRange={dateRange} selectedYear={selectedYear} selectedEvent={selectedEvent} selectedCategory={selectedCategory} />
                </Col>
                {/* <Col span={12}>
                    <RegistrationChannelView />
                </Col> */}
                <Col span={12} className="respn_col">
                    <RegistrationAbandonmentView data={abandonmentrate} isLoading={isFetching} />
                </Col>
                <Col span={12} className="respn_col">
                    <RepeatParticipationView dateRange={dateRange} selectedYear={selectedYear} selectedEvent={selectedEvent} selectedCategory={selectedCategory} />
                </Col>
            </Row>
        </Fragment>
    );
};
